import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";
// import { Router ,NavigationEnd } from "@angular/router";
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { CreditCardActions } from "./credit-card.actions";

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss']
})
export class CreditCardComponent implements OnInit {

    actionType: any;
    amount: any;
    backendURL: any;
    currency: any;
    merchantCode: any;
    paymentId: any;
    prodDesc: any;
    refNo: any;
    responseURL: any;
    signature: any;
    signatureType: any;
    userContact: any;
    userEmail: any;
    userName: any;
    remark: any;
    purchaseOptionMessage: any;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {

        //console.log('this.route.queryParams', this.route.queryParams);

        this.route.queryParams.subscribe(params => {

            this.actionType= params.ActionType;
            this.amount= params.Amount;
            this.backendURL= params.BackendURL;
            this.currency= params.Currency;
            this.merchantCode= params.MerchantCode;
            this.paymentId=  parseInt(params.PaymentId);
            this.refNo= params.RefNo;
            this.responseURL= params.ResponseURL;
            this.signature= params.Signature;
            this.signatureType= params.SignatureType;
            this.userContact= params.UserContact;
            this.userEmail= params.UserEmail;
            this.userName= params.UserName;
            this.remark= params.Remark;
            this.prodDesc=params.ProdDesc;

            if(params.PurchaseOption === 'Change Plan'){
                this.purchaseOptionMessage="Thank you for your loyalty!  We will now proceed to pre-authorize your credit card for auto-billing and device payment top up (if any).  Please click proceed.";
            }else {
                // this.purchaseOptionMessage="You’re good to go! Please click proceed to pre-authorise your credit card for auto billing enrolment, device top up, and advance payment (if any).";
                this.purchaseOptionMessage="To complete your application, please click proceed to pre-authorize your credit/debit card for autobilling and if you have device top-up payment.";
            }

        });
    }

}
